import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AspClutchKitDetailsService {

  constructor(  private http: HttpClient,) { }

  getClutchSuggestions(
    relevancyCount,
    variant,
    partNames,
    garageKey,
    regNo
  ): Observable<any> {

    const headers = new HttpHeaders({
      'x-api-key': `${GlobalVariable.AUTOVERSE_ELASTIC_KEY}`,
    });

    const partNameValue = partNames || 'String';
    const variantValue = variant || 'String';

    return this.http.get(
      `${GlobalVariable.BASE_API_URL_ELASTIC}/part-name-suggestions-warehouse` +
      `?partNames=${partNameValue}` +
      `&variant=${variantValue}` +
      `&relevancyCount=${relevancyCount}` +
      `&garageKey=${garageKey}` +
      `&regNo=${regNo}` +
      `&instantDelivery=1` +
      `&userKey=${localStorage.getItem('spareUserKey')}` +
      `&source=web` +
      `&userType=agent` +
      `&autoverseCredit=false`,
      { headers }
    );
  }
  instantOrder(payload: any) {

    return this.http.post(
      `${GlobalVariable.BASE_API_URL_ELASTIC}/order/instantOrder`,
      payload,
      {
        headers: new HttpHeaders({
          'x-api-key': `${GlobalVariable.AUTOVERSE_ELASTIC_KEY}`,
          'Content-Type': 'application/json'
        })
      }
    );
  }
}
